import React from 'react';

import EmailDomainStateComponent from 'src/presentation/components/pages/email/components/EmailDomainStateComponent';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { EmailDomainState } from 'src/models/Email/EmailDomain';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import { StepDescription, StepWizardActionContainer, StepWizardField } from './StepWizardLayout';

const AddEmailDomainStep3 = ({ firstStep, onDone }: { firstStep?; onDone }): JSX.Element | null => {
  const addAnotherHandler = () => {
    firstStep();
  };

  return (
    <>
      <StepWizardField>
        <H3 data-aid="wizard-title">Wait for your sending domain DNS records to update</H3>
        <StepDescription data-aid="wizard-description">
          Allow up to 72 hours for your DNS provider to verify your sending domain SPF and DKIM records. When the
          verification status changes from <EmailDomainStateComponent state={EmailDomainState.UNVERIFIED} /> to{' '}
          <EmailDomainStateComponent state={EmailDomainState.ACTIVE} />, your sending domain is ready to use in Gladly.
        </StepDescription>
      </StepWizardField>

      <StepWizardActionContainer>
        <Button onClick={onDone} data-aid="step3-done-button">
          Done
        </Button>

        <Button onClick={addAnotherHandler} data-aid="add-another-domain-button" type={Button.Types.SECONDARY}>
          Add another domain
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

export default AddEmailDomainStep3;
